import _styled from "@emotion/styled/base";
import { getResetByTag, utilityStyles } from './../../../styles';
var resetStyles = getResetByTag('div');
var StyledTileLabel = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  target: "eyw48rz0"
} : {
  target: "eyw48rz0",
  label: "StyledTileLabel"
})(resetStyles, utilityStyles);
export default StyledTileLabel;